import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FieldController } from "../../../../Form";
import { GiftCardFormProps } from "../../../types";
import { Button } from "../../../../../ui/CTA";
import { Input, PasswordInput } from "../../../../../ui/Fields";
import styles from './GiftCardForm.module.scss';
const GiftCardForm = ({ labels, disabled }) => {
    const { formState } = useFormContext();
    const isDisabled = !formState.isValid || disabled;
    return (React.createElement(React.Fragment, null,
        React.createElement(FieldController, { required: true, rules: {
                required: true,
                minLength: {
                    value: 19,
                    message: labels.cardNumberTooShort,
                },
            }, name: "cardNumber", label: labels.giftCardNumber, className: styles.cardNumber, hint: `19 ${labels.digits}`, maxLength: 19, iconPosition: "end", disabled: disabled, as: React.createElement(Input, null) }),
        React.createElement(FieldController, { required: true, rules: {
                required: true,
                minLength: {
                    value: 4,
                    message: labels.pinCodeTooShort,
                },
            }, name: "cardPin", label: labels.pinCode, className: styles.cardPin, hint: `4 ${labels.digits}`, maxLength: 4, disableSecureCheck: true, disabled: disabled, as: React.createElement(PasswordInput, null) }),
        React.createElement(Button, { type: "submit", className: styles.addButton, disabled: isDisabled }, labels.add)));
};
export default GiftCardForm;
//# sourceMappingURL=GiftCardForm.js.map